import { createReducer } from '@reduxjs/toolkit';
import * as permissionActions from '../actions/permission.action';

export const initialState = {
  addons: null,
  template: null,
  element: null
};

const setTemplatePermission = (state, { payload }) => {
  const { addons, ...template } = payload || {};

  state.template = template;
  state.addons = addons;
};

const setElementPermission = (state, { payload }) => {
  state.element = payload;
};

export default createReducer(initialState, builder => {
  builder
    .addCase(permissionActions.setTemplatePermission, setTemplatePermission)
    .addCase(permissionActions.setElementPermission, setElementPermission);
});
